import LayoutPublic from './public'
import LayoutDefault from './default'
export default {
  LayoutPublic,
  LayoutDefault
}
